/** Import hooks */

import { Cleaner } from "../Misc/ObjectCleaner";

const

DEFAULT_PAGE_SIZE = 21,

PAGINATION_KEYS = [ "f", "l", "b", "a", "p", "lp" ],

normalizePageSize = value => {
    const parsed = parseInt ( value );

    if ( isNaN ( parsed ) || parsed <= 0 || parsed === 12 ) return DEFAULT_PAGE_SIZE;

    return parsed;
},

/** @returns URL parameters */

RimsNavigator = ( params, update ) => { const parameters = new URLSearchParams ( params ),

    /** Register attributes */

    attributes = {

        f       : parseInt      ( parameters.get ( "f" ) ),

        l       : parseInt      ( parameters.get ( "l" ) ),

        b       : parameters.get ( "b" ),

        a       : parameters.get ( "a" ),

        m       : parameters.get ( "m" ),

        mo      : parameters.get ( "mo" ),
        
        pcd     : parameters.get ( "pcd" ),

        o       : parameters.get ( "o" ),

        pr      : parameters.get ( "pr" ),

        r       : parameters.get ( "r" ),

        sort    : parameters.get ( "sort" ),

        av      : parameters.get ( "av" ),

        lp      : parameters.get ( "lp" ),

        p       : parseInt      ( parameters.get ( "p" ) )

    },

    nextAttributes = Cleaner ( { ...attributes, ...update } ),

    shouldResetPage = update && Object.keys ( update ).some ( key => ! PAGINATION_KEYS.includes ( key ) );

    if ( shouldResetPage ) {

        nextAttributes.p  = 1;

        nextAttributes.a  = null;

        nextAttributes.b  = null;

        nextAttributes.lp = null;

    }

    if ( ! nextAttributes.p || nextAttributes.p < 1 ) nextAttributes.p = 1;

    if ( nextAttributes.lp ) {
        nextAttributes.f = null;
        nextAttributes.l = normalizePageSize ( nextAttributes.l );
        nextAttributes.a = null;
        nextAttributes.b = null;
    } else if ( nextAttributes.b ) {
        nextAttributes.l = normalizePageSize ( nextAttributes.l );
        nextAttributes.f = null;
    } else {
        nextAttributes.f = normalizePageSize ( nextAttributes.f );
        nextAttributes.l = null;
    }

    /** Optimize, clean & return attributes */

    return Cleaner ( nextAttributes );

},

/** @returns Query attributes based on URL parameters */

QueryAttributes = ( params ) => { const parameters = new URLSearchParams ( params );

    const before = parameters.get ( "b" ),

    lastPage = parameters.get ( "lp" ),

    first = before || lastPage ? null : normalizePageSize ( parameters.get ( "f" ) ),

    last = before || lastPage ? normalizePageSize ( parameters.get ( "l" ) ) : null;

    /** Optimize, clean & return query attributes */

    return Cleaner ( {

        first                       : first,

        last                        : last,

        before                      : before,

        after                       : parameters.get ( "a" ),

        sortOrder                   : parameters.get ( "sort" ),

        manufacturer                : parameters.get ( "m" ) ? parameters.get ( "m" ).split ( "," ) : [],

        diameter                    : parameters.get ( "r" ) ? parameters.get ( "r" ).split ( "," ).map ( radius => radius ) : [],

        model                       : parameters.get ( "mo" ) ? parameters.get ( "mo" ).split ( "," ) : [],

        offset                      : parseInt ( parameters.get ( "o" ) ),

        upperPriceRange             : ( params.get("pr") ) ? parseInt ( params.get("pr").split ( "," )[1] ) : null,
        
        lowerPriceRange             : ( params.get("pr") ) ? parseInt ( params.get("pr").split ( "," )[0] ) : null,

        pitchCircleDiameter         : parameters.get ( "pcd" ),

        availability                : parameters.get ( "av" ) ? parameters.get ( "av" ).split ( "," ) : []

    } );

};

/** Export hooks */
 
export { RimsNavigator, QueryAttributes };